/**
 * VIP Custom Payment - /vip/:nombre
 *
 * Personalized payment page with free amount. **Stripe-only para todos los
 * países, incluida Argentina** (ver `src/lib/paymentProviderPolicy.ts`).
 * MercadoPago fue retirado del checkout; ya no existe la variante
 * `VipPaymentAR` (brick MP). Los suscriptores históricos MP siguen
 * procesándose por los webhooks de `api/mercadopago/*`.
 */

import { lazy, Suspense } from "react";
import { useParams } from "react-router-dom";
import { useTemplateSelection } from "@/hooks/useTemplateSelection";
import { isVipAvailable } from "@/config/vipConfig";
import { Loader2 } from "lucide-react";

const VipPaymentIntl = lazy(() =>
  import("@/components/templates/VipPaymentIntl")
);

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-500/20 via-purple-500/20 to-blue-500/20">
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 animate-spin text-pink-400 mx-auto" />
        <p className="text-white/80 text-sm">Cargando...</p>
      </div>
    </div>
  );
}

export default function VipCustomPayment() {
  const { nombre } = useParams<{ nombre: string }>();
  const { country } = useTemplateSelection();

  const displayName = nombre
    ? nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase()
    : "VIP";

  const vipAvailable = isVipAvailable();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <VipPaymentIntl
        nombre={displayName}
        isAvailable={vipAvailable}
        country={country ?? null}
      />
    </Suspense>
  );
}
